import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var ExpandMore = function ExpandMore(props) {
  useDeprecatedComponentWarning({
    component: 'ExpandMore'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M354 183l30 30-128 128-128-128 30-30 98 98z"
  }));
};

ExpandMore.displayName = 'ExpandMore';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ExpandMore.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default ExpandMore;